import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=4be1497c&scoped=true&"
import script from "./PayPal.vue?vue&type=script&lang=js&"
export * from "./PayPal.vue?vue&type=script&lang=js&"
import style0 from "./PayPal.vue?vue&type=style&index=0&id=4be1497c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1497c",
  null
  
)

/* custom blocks */
import block0 from "./PayPal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports